/**
 * Helper functions per ottenere i dati utente corrente
 * Compatibile sia con auth.currentUser che con lo stato locale user
 */

export function getCurrentUser(authUser: any, localUser: any) {
  // Priorità: auth nativo -> stato locale -> null
  if (authUser?.getCurrentUser) {
    return authUser.getCurrentUser; // Getter, non metodo
  }
  if (authUser?.currentUser) {
    return authUser.currentUser;
  }
  return localUser;
}

export function getCurrentUserId(authUser: any, localUser: any): string {
  const user = getCurrentUser(authUser, localUser);
  return user?.uid || user?.id || 'anonymous';
}

export function getCurrentUserEmail(authUser: any, localUser: any): string {
  const user = getCurrentUser(authUser, localUser);
  return user?.email || 'anonymous';
}

export function getCurrentUserName(authUser: any, localUser: any, fallback?: string): string {
  const user = getCurrentUser(authUser, localUser);
  return user?.displayName || user?.name || fallback || 'Anonymous';
}
